import { useTranslation } from '@/i18n';
import {
  FormRadioButton,
  FormRadioButtonProps,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { ReactNode, memo, useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import styles from './radioGroupWithOtherInput.module.scss';

const cx = classnames.bind(styles);

type Options = {
  label: string;
  value: string;
};

export type Props<TFieldValues extends FieldValues> = {
  options: Options[];
  required: boolean;
  inputId: string;
  otherInput?: ReactNode;
} & Omit<FormRadioButtonProps<TFieldValues>, ''>;

const _RadioGroupWithOtherInput = <TFieldValues extends FieldValues>({
  options,
  otherInput,
  required,
  disabled = false,
  ...rest
}: Props<TFieldValues>) => {
  const { t } = useTranslation();
  const rules = useMemo(() => {
    return {
      required: !disabled && required ? t('required') : false,
    };
  }, [disabled, required, t]);

  return (
    <div className={cx(styles['any-select-wrapper'])}>
      <div>
        <FormRadioButton<TFieldValues>
          {...rest}
          vertical
          rules={rules}
          name={rest.name}
          control={rest.control}
          options={options}
          disabled={disabled}
        />
      </div>
      {otherInput}
    </div>
  );
};
_RadioGroupWithOtherInput.displayName = '_RadioGroupWithOtherInput';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const RadioGroupWithOtherInput = memo((props) => (
  <_RadioGroupWithOtherInput {...props} />
)) as typeof _RadioGroupWithOtherInput;
RadioGroupWithOtherInput.displayName = 'RadioGroupWithOtherInput';
